import { useOutletContext } from 'react-router-dom';
import { ProductType } from '~/models/product/ProductType';
import { MappedCampaign } from '../campaign.utils';
import { ProductGroupComponent } from '../components/ProductGroup';

export const SelectPremiumProducts: React.FC = () => {
  const campaign = useOutletContext<MappedCampaign>();
  return <ProductGroupComponent group={campaign.products.premium} config={campaign.configs.premium} type={ProductType.Premium} />;
};
